import axios, { AxiosResponse } from "axios";
import { CountryStates, DealerConsentDealerAttributes, DealerConsentDealerAttributesResponse, DealerConsentDealerInformation, DealerConsentProgramsResponse } from "types/consent";

const PL2Url = process.env.REACT_APP_PL20API_URL || "";
const PL2Code = process.env.REACT_APP_PL20API_CODE || "";

export const DealerConsentAPI = {
  // -------------------------------------------------------------
  // SubmitDealerConsent
  // -------------------------------------------------------------
  submitDealerConsent: async (
    dealerAttributes: DealerConsentDealerAttributes
  ): Promise<DealerConsentDealerAttributesResponse> => {
    const url = `${PL2Url}/dealerconsent/submitconsent/${PL2Code}`;
    const { dmsLegalName, ...serializedDealerAttributes } = dealerAttributes;
    const { data } = await axios.put<DealerConsentDealerAttributesResponse>(url, serializedDealerAttributes);
    return data;
  },
  // ------------------------------------------------------------
  // GetDealerConsentPrograms
  // ------------------------------------------------------------
  getDealerConsentPrograms: async (systemId: string): Promise<DealerConsentProgramsResponse> => {
    const url = `${PL2Url}/dealerconsent/programs/${systemId}${PL2Code}`;
    const { data } = await axios.get<DealerConsentProgramsResponse>(url);
    return data;
  }, 
  getDealerConsentProgramsV2: async (systemId: string, dmsType: number): Promise<DealerConsentProgramsResponse> => {
    const url = `${PL2Url}/dealerconsent/programs/${systemId}/${dmsType}${PL2Code}`;
    const { data } = await axios.get<DealerConsentProgramsResponse>(url);
    return data;
  },
  // ------------------------------------------------------------
  // GetDealerConsentPrograms
  // ------------------------------------------------------------
  verifyDmsCustomerId: async (
    dmsCustomerId: string, dealerZip: string
  ): Promise<DealerConsentDealerInformation> => {
    const url = `${PL2Url}/dealerconsent/verifydmscustomerid/${dmsCustomerId}/${dealerZip}${PL2Code}`;
    const { data } = await axios.get<DealerConsentDealerInformation>(url);
    return data;
  },
  // ------------------------------------------------------------
  // GetDealerConsentPrograms
  // ------------------------------------------------------------
  getUserIpAddress: async (): Promise<AxiosResponse<any, any>> => {
    const data  = axios.get('https://api.ipify.org?format=json');
    return data;
  }, 
  // ------------------------------------------------------------
  // GetDealerConsentPrograms
  // ------------------------------------------------------------
  getProgramTerms: async (
    agreementURL: string
  ): Promise<string> => {
    const data = await fetch(agreementURL);
    const terms = await data.text();
    return terms;
  }, 
  // ------------------------------------------------------------
  // GetDealerConsentPrograms
  // ------------------------------------------------------------
  getCountryStates: async (): Promise<CountryStates[]> => {
    const url = `${PL2Url}/dealerconsent/countrystates/${PL2Code}`;
    const { data } = await axios.get<CountryStates[]>(url);
    return data;
  },
  // ------------------------------------------------------------
  // GetDealerConsentPrograms
  // ------------------------------------------------------------
  getDealerInformation: async (
    systemId: string
  ): Promise<DealerConsentDealerInformation> => {
    const url = `${PL2Url}/dealerconsent/getdealerinformation/${systemId}${PL2Code}`;
    const { data } = await axios.get<DealerConsentDealerInformation>(url);
    return data;
  },
  
  getDealerInformationV2: async (systemId: string, dmsType: number): Promise<DealerConsentDealerInformation> => {
    const url = `${PL2Url}/dealerconsent/getdealerinformation/${systemId}/${dmsType}${PL2Code}`;
    const { data } = await axios.get<DealerConsentDealerInformation>(url);
    return data;
  },

  getDealerInformationByDealerId: async (dealerId: number): Promise<DealerConsentDealerInformation> => {
   const url = `${PL2Url}/dealerconsent/identity/bydealerid/${dealerId}${PL2Code}`;
   const { data } = await axios.get<DealerConsentDealerInformation>(url);
   return data;
  },

};

export default DealerConsentAPI;